import { render, staticRenderFns } from "./AddInvoiceModal.vue?vue&type=template&id=5c4630a2&scoped=true"
import script from "./AddInvoiceModal.vue?vue&type=script&lang=ts"
export * from "./AddInvoiceModal.vue?vue&type=script&lang=ts"
import style0 from "./AddInvoiceModal.vue?vue&type=style&index=0&id=5c4630a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4630a2",
  null
  
)

export default component.exports